import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const pct = (v) => `${(v * 100).toFixed(1)}%`;

const Tile = ({ label, value, sub, testId, tone }) => (
  <div data-testid={testId} className="bg-[#131927] p-4 outline outline-1 outline-slate-800 sm:p-5">
    <div className="eyebrow">{label}</div>
    <div className={`mt-2 font-data text-3xl font-bold ${tone || "text-white"}`}>{value}</div>
    {sub && <div className="mt-1 font-data text-[11px] text-slate-500">{sub}</div>}
  </div>
);

export const XgPanel = ({ stats: s, position }) => {
  const [model, setModel] = useState(null);
  useEffect(() => { api.get("/xg/model").then((r) => setModel(r.data)).catch(() => {}); }, []);
  const diff = s.goals_minus_xg ?? 0;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 overflow-hidden rounded-lg border border-slate-800 sm:grid-cols-3">
        <Tile label="xG" value={s.xg.toFixed(2)} sub={`npxG ${(s.npxg ?? 0).toFixed(2)}`} testId="xg-total" />
        <Tile label="xG / Game" value={s.xg_per_game != null ? s.xg_per_game.toFixed(2) : "—"}
          sub={`${s.pbp_games ?? 0} games with play-by-play`} testId="xg-per-game" />
        <Tile label="Goals − xG" value={`${diff > 0 ? "+" : ""}${diff.toFixed(2)}`} testId="xg-goals-minus"
          tone={diff > 0.05 ? "text-emerald-400" : diff < -0.05 ? "text-red-400" : "text-white"} sub={`${s.goals ?? 0} goals`} />
        <Tile label="Non-pen shots" value={s.np_shots ?? 0} testId="xg-np-shots" />
        <Tile label="Shrunk finishing" value={pct(s.finishing_rate)} testId="xg-finishing"
          sub={`90% interval ${pct(s.finishing_low)} – ${pct(s.finishing_high)}`} />
        <Tile label="League rate" value={pct(s.xg_league_rate)} sub={`Goals per shot · ${position || "Midfielder"}`} testId="xg-league-rate" />
      </div>
      <p data-testid="xg-method-note" className="text-xs leading-relaxed text-slate-500">
        Box Score xG = non-penalty shots × league goals per shot for her position
        {model ? ` + ${model.penalty_xg} per penalty taken. Finishing rate blends her record with ${model.prior_shots} league-average shots.` : "."}
        {" "}Built from play-by-play, so per-game values only count games FanFlare covered. Measures chance volume, not shot location.
      </p>
    </div>
  );
};
